// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2808":"6e406731","5306":"128e2007","6803":"143848ab"}[chunkId] + ".chunk.css";
};